import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';


const PlanModal = ({ isOpen, setIsOpen, editData, fetchPlans }) => {
    const [data, setData] = useState({
        article_category: "",
        base_price: "",
        final_price: "",
        status: "",
        position: ""
    });

    useEffect(() => {
        if (editData) {
            setData(editData);
        } else {
            setData({
                article_category: "",
                base_price: "",
                final_price: "",
                status: "",
                position: ""
            });
        }
    }, [editData]);

    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    const categoryOptions = [
        { label: "Original Research Article", value: "Original Research Article" },
        { label: "Review Article", value: "Review Article" },
        { label: "Case Study", value: "Case Study" },
        { label: "Short Communication", value: "Short Communication" },
        { label: "Book Chapter", value: "Book Chapter" }
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData(prev => ({ ...prev, [name]: value }));
    };

    const handleSelectChange = (selected, { name }) => {
        setData(prev => ({ ...prev, [name]: selected ? selected.value : "" }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const method = editData ? "PUT" : "POST";
        const url = editData ? `https://releasesworld.100billionoms.com/plan/${editData.id}` : "https://releasesworld.100billionoms.com/plan";

        try {
            const response = await fetch(url, {
                method,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data)
            });
            if (response.ok) {
                toast.success(editData?"Plan Updated":"Plan Added")
                fetchPlans();
                setIsOpen(false);
            } else {
                const error = await response.json();
                toast.error(error.message)
                console.error("Server Error:", error.message);
            }
        } catch (error) {
            toast.error(error)
            console.error("Request Error:", error);
        }
    };

   

    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()}
            >
                <h2 className="oms-modal-title">{editData ? "Edit Plan" : "Add Plan"}</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-flex">
                        <div className="oms-form-group">
                            <label className="oms-form-label">Article Category</label>
                            <Select
                                name="article_category"
                                options={categoryOptions}
                                value={categoryOptions.find(opt => opt.value === data.article_category)}
                                onChange={handleSelectChange}
                                placeholder="Select Article Category"
                            />
                        </div>
                        <div className="oms-form-group">
                            <label className="oms-form-label">Base Price</label>
                            <input type="number" name="base_price" value={data.base_price} onChange={handleChange} onWheel={(e) => e.target.blur()} placeholder="Enter base price" />
                        </div>
                        <div className="oms-form-group">
                            <label className="oms-form-label">Final Price</label>
                            <input type="number" name="final_price" value={data.final_price} onChange={handleChange} onWheel={(e) => e.target.blur()} placeholder="Enter final price" />
                        </div>
                        <div className="oms-form-group">
                            <label className="oms-form-label">Position</label>
                            <input type="number" name="position" value={data.position} onChange={handleChange} onWheel={(e) => e.target.blur()} placeholder="Enter position" />
                        </div>
                        <div className="oms-form-group">
                            <label className="oms-form-label">Status</label>
                            <Select
                                name="status"
                                options={statusOptions}
                                value={statusOptions.find(opt => opt.value === data.status)}
                                onChange={handleSelectChange}
                                placeholder="Select status"
                            />
                        </div>
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
                        <button type="submit">{editData ? "Update" : "Submit"}</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default PlanModal;
